import { PROJECT_ID, WHITELABEL_NAME as ACTIVE_WHITELABEL } from '@/core/consts/wl';
import { LANDING_URL, ZITADEL_API_URL } from './env';

declare const isProd: string;
declare const isFederation: string;
const WHITELABEL_NAME = process.env.WHITELABEL;
const useFederationMode = isProd || isFederation;

export let REDIRECT_URI: string;

if (useFederationMode) {
  REDIRECT_URI = `${window.location.origin}/fly/charter/callback`;
} else {
  REDIRECT_URI = `${window.location.origin}/callback?_wl_=${WHITELABEL_NAME}`;
}

export let POST_LOGOUT_REDIRECT_URI: string;

if (useFederationMode) {
  POST_LOGOUT_REDIRECT_URI = `${LANDING_URL}/fly/charter`;
} else {
  POST_LOGOUT_REDIRECT_URI = `${window.location.origin}/?_wl_=${WHITELABEL_NAME}`;
}

export const OIDC_AMAAS_SCOPE = `urn:zitadel:iam:user:resourceowner urn:zitadel:iam:org:project:id:${PROJECT_ID}:aud`;
export const OIDC_AMAAS_ROLES = `urn:zitadel:iam:org:project:${PROJECT_ID}:roles`;
/**
 * Served by the SPA fallback (dev historyApiFallback, prod nginx try_files), so a hidden
 * silent-renew iframe landing here would boot a second copy of the whole app. `src/index.ts`
 * matches on this path to load `silentCallback` instead — see the note there.
 */
export const SILENT_REDIRECT_PATH = '/silent_login';
export const SILENT_REDIRECT_URI = `${window.location.origin}${SILENT_REDIRECT_PATH}`;
export const REDIRECT_URIS = [SILENT_REDIRECT_URI, REDIRECT_URI];

const LOGIN_BASE_PATH = ACTIVE_WHITELABEL === 'mira' ? '/mira/login' : '/charter/login';
export const SEAMLESS_AUTH_URL = `${ZITADEL_API_URL}${LOGIN_BASE_PATH}/seamless-login`;
